// extracted by mini-css-extract-plugin
module.exports = {"dialogOrderDetails":"DialogOrderDetails_dialogOrderDetails_1azUn"};